import { PROJECT_DIAGRAM_RESCALE_PARAM } from 'src/constants/project';

export const getProjectRoute = (
  projectId: string,
  options?: { rescale?: boolean }
) => {
  const basePath = `/projects/${projectId}`;
  if (options?.rescale) {
    return `${basePath}?${PROJECT_DIAGRAM_RESCALE_PARAM}`;
  }
  return basePath;
};
